import { render, staticRenderFns } from "./newImage.vue?vue&type=template&id=04c46172&scoped=true&"
import script from "./newImage.vue?vue&type=script&lang=js&"
export * from "./newImage.vue?vue&type=script&lang=js&"
import style0 from "./newImage.vue?vue&type=style&index=0&id=04c46172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c46172",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VIcon,VTimelineItem})
